import { get, partial } from 'lodash/fp';
import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const baseUrl = '/resourceBlocks';

export default function ResourceBlockComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, baseUrl);
    // @ts-expect-error $TSFixMeError: Argument of type 'LodashGet5x1' is not assignable to parameter of type 'LodashIdentity'.
    return type.create(ResourceBlockComponent, searchable(partial(request, ['/search']), get('resourceBlocks')), {
        getAll({ enterpriseId, resourceBlockIds }: $TSFixMe) {
            return request('/getAll', { enterpriseId, resourceBlockIds });
        },
    });
}
